import { Fragment, type ReactNode } from "react";

const PLACEHOLDER = /\{(\w+)\}/g;

/**
 * Interpolate React nodes (links, buttons) into a translated template, e.g.
 * `"Read our {privacyLink}."` with `{ privacyLink: <Link … /> }`. Word order
 * differs between languages, so links are placed by the translation rather
 * than by the component. Unknown placeholders are left untouched.
 */
export function richText(
  template: string,
  values: Record<string, ReactNode>,
): ReactNode {
  const parts: ReactNode[] = [];
  let cursor = 0;

  for (const match of template.matchAll(PLACEHOLDER)) {
    const [placeholder, name] = match;
    const index = match.index ?? 0;

    if (!(name in values)) continue;
    if (index > cursor) parts.push(template.slice(cursor, index));
    parts.push(<Fragment key={`${name}-${index}`}>{values[name]}</Fragment>);
    cursor = index + placeholder.length;
  }

  if (cursor < template.length) parts.push(template.slice(cursor));

  return parts.length === 1 ? parts[0] : parts;
}
